export default __webpack_public_path__ + "static/media/udenskritums.f7cbc6eb.jpg";